"use strict";

exports.__esModule = true;
exports.resolveWithPatterns = resolveWithPatterns;

var _Identifiers = require("../types/Identifiers");

var _buildOgImage = require("./build-og-image");

var _resolvePayload = require("./resolve-payload");

var _sort = require("./sort");

var _updateByIdentifier = require("../tags/values/update-by-identifier");

var _getByIdentifier = require("../tags/values/get-by-identifier");

var _fillInPatternBlob = require("../patterns/fill-in-pattern-blob");

var _getLink = require("./utils/get-link");

var _adapterStaticPage = _interopRequireDefault(require("../adapters/static-page/adapter-static-page"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function resolveWithPatterns(payload, context) {
  context = context || {};
  var result = (0, _resolvePayload.resolvePayload)(payload);
  var robots = (0, _getByIdentifier.getValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS);
  var isIndexableBySchema = robots === 'index' || robots === '';

  if (isIndexableBySchema) {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, '');
  }

  if (!isIndexableBySchema && preventIndex(context)) {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, 'noindex');
  }

  result.tags = result.tags.concat((0, _getLink.getLink)(context, _adapterStaticPage["default"].IDs.NEXT, 'next')).concat((0, _getLink.getLink)(context, _adapterStaticPage["default"].IDs.PREV, 'prev'));
  result = (0, _fillInPatternBlob.fillInPatternBlob)(result, context);
  result.tags = (0, _buildOgImage.applyOgImageModifications)(result.tags);
  result.tags = (0, _sort.sort)(result.tags);
  return result;
}

function preventIndex(context) {
  return !context[_adapterStaticPage["default"].IDs.INDEX_SITE] || !context[_adapterStaticPage["default"].IDs.INDEX_PAGE];
}